module.exports = __webpack_public_path__ + "static/media/arrow-right-selected.b8c3b355.svg";